
import React, { useState } from 'react';
import { UserRole, Plan, User as UserType, Company, Order } from './types.ts';
import { TabButton } from './SharedComponents.tsx';

// Importando seções modulares
import { SettingsProfile } from './SettingsProfile.tsx';
import { SettingsGateways } from './SettingsGateways.tsx';
import { SettingsNotifications } from './SettingsNotifications.tsx';
import { SettingsPlans } from './SettingsPlans.tsx';
import { SettingsSecurity } from './SettingsSecurity.tsx';
import { SettingsSmtp } from './SettingsSmtp.tsx';
import { SettingsUnit } from './SettingsUnit.tsx';
import { SettingsEmailTemplates } from './SettingsEmailTemplates.tsx';

interface SettingsPageProps {
  currentUser: UserType;
  currentCompany?: Company;
  users: UserType[];
  plans: Plan[];
  onUpdatePlan: (plan: Plan) => void;
  onUpdateUsers: (newUsers: UserType[]) => void;
  onUpdateUser: (u: UserType) => void;
  onUpdateCompany: (c: Partial<Company>) => void;
  addNotification: (title: string, message: string, type: 'info' | 'warning' | 'error' | 'success') => void;
}

export const SettingsPage = ({ currentUser, currentCompany, users, plans, onUpdatePlan, onUpdateUsers, onUpdateUser, onUpdateCompany, addNotification }: SettingsPageProps) => {
  const [activeSubTab, setActiveSubTab] = useState('unit');
  const isSuperAdmin = currentUser.role === UserRole.SUPER_ADMIN;
  const isManager = currentUser.role === UserRole.ADMIN || isSuperAdmin;

  const handleUpdateUnit = (updates: any) => {
    onUpdateCompany(updates);
    addNotification('Configurações', 'Dados da unidade atualizados com sucesso.', 'success');
  };

  // Se não for gestor, a aba padrão deve ser 'profile'
  useState(() => {
    if (!isManager && activeSubTab === 'unit') {
      setActiveSubTab('profile');
    }
  });

  return (
    <div className={`max-w-6xl mx-auto space-y-6 animate-in fade-in duration-500 pb-20 ${isSuperAdmin ? 'p-10' : ''}`}>
      <div className={`flex border-b overflow-x-auto scrollbar-hide ${isSuperAdmin ? 'border-white/10' : 'border-gray-200'}`}>
        {isManager && <TabButton active={activeSubTab === 'unit'} onClick={() => setActiveSubTab('unit')}>Unidade</TabButton>}
        <TabButton active={activeSubTab === 'profile'} onClick={() => setActiveSubTab('profile')}>Meu Perfil</TabButton>
        {isSuperAdmin && (
          <>
            <TabButton active={activeSubTab === 'gateways'} onClick={() => setActiveSubTab('gateways')}>Gateways Pagto</TabButton>
            <TabButton active={activeSubTab === 'plans'} onClick={() => setActiveSubTab('plans')}>Planos SaaS</TabButton>
            <TabButton active={activeSubTab === 'smtp'} onClick={() => setActiveSubTab('smtp')}>E-mail (SMTP)</TabButton>
          </>
        )}
        {isManager && <TabButton active={activeSubTab === 'templates'} onClick={() => setActiveSubTab('templates')}>Templates Onboarding</TabButton>}
        <TabButton active={activeSubTab === 'notifications'} onClick={() => setActiveSubTab('notifications')}>Notificações</TabButton>
        <TabButton active={activeSubTab === 'security'} onClick={() => setActiveSubTab('security')}>Segurança</TabButton>
      </div>

      <div className="mt-6">
        {activeSubTab === 'unit' && isManager && <SettingsUnit company={currentCompany} onUpdate={handleUpdateUnit} />}
        {activeSubTab === 'profile' && <SettingsProfile user={currentUser} company={currentCompany} isSuper={isSuperAdmin} onUpdate={onUpdateUser} />}
        {activeSubTab === 'gateways' && isSuperAdmin && <SettingsGateways isSuper={isSuperAdmin} />}
        {activeSubTab === 'plans' && isSuperAdmin && <SettingsPlans plans={plans} isSuperAdmin={isSuperAdmin} onUpdatePlan={onUpdatePlan} />}
        {activeSubTab === 'smtp' && isSuperAdmin && <SettingsSmtp isSuper={isSuperAdmin} />}
        {activeSubTab === 'templates' && isManager && <SettingsEmailTemplates company={currentCompany} user={currentUser} isSuper={isSuperAdmin} />}
        {activeSubTab === 'notifications' && <SettingsNotifications isSuper={isSuperAdmin} />}
        {activeSubTab === 'security' && <SettingsSecurity isSuper={isSuperAdmin} />}
      </div>
    </div>
  );
};
